export const AW_FRONTEND_AI_URL = process.env?.AWAPI_AW_FRONTEND_AI_URL || '/aw-frontend-ai';

export const AW_FRONTEND_AI_FILTER_CHAT_PATH = '/api/filter/chat';
